import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { ICity } from "src/interface/ICity";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { API_URL, BootstrapTooltip } from "src/utilities";
import { IUser } from "src/interface/IUser";
import SkeltonProgress from "../../components/SkeltonProgress";
import { DialogContent } from "@mui/material";
import GridViewMUIX from "../../components/GridViewMUIX";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModel,
  GridRowModes,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import moment from "jalali-moment";
import { useNotifications } from "@toolpad/core/useNotifications";
import { IProvince } from "src/interface/IProvince";
import { useMutation } from "@tanstack/react-query";
import PopoverComponent from "../../components/PopoverComponent";
import NewCity from "./new-city";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Cities({
  open,
  setOpen,
  provinceInfo,
  user,
  refetch,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  provinceInfo: IProvince;
  user: IUser;
  refetch: () => void;
}) {
  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(API_URL + "cities/" + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async () => {
      const response = await fetch(API_URL + "cities/" + cityId, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>(
    {}
  );
  const [cityId, setCityId] = React.useState("");
  const [openNewCity, setOpenNewCity] = React.useState<boolean>(false);
  const notifications = useNotifications();
  const [anchorDeleteEl, setAnchorDeleteEl] =
    React.useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;
  const handleDeleteClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    id: string
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setCityId(id);
  };
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "نام",
      flex: 1,

      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      editable: true,
      sortable: false,
    },
    {
      field: "lat&long",
      minWidth: 180,
      align: "left",
      headerName: "موقعیت مکانی",
      editable: true,
      sortable: true,
      // type: "singleSelect",
      // getOptionValue: (value: any) => value.value,
      // getOptionLabel: (value: any) => value.label,
      // valueOptions: [
      //   { value: BaseDefinitionType.CarType, label: "نوع ماشین" },
      //   { value: BaseDefinitionType.Color, label: "رنگ" },
      //   { value: BaseDefinitionType.MaterialType, label: "محتوایت بار" },
      //   { value: BaseDefinitionType.PackageType, label: "نوع بسته بندی" },
      // ],
    },

    {
      field: "createdOn",
      headerName: "تاریخ ثبت",
      sortable: true,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "modifiedOn",
      headerName: "آخرین تغییرات",
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
    },
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 150,
      getActions: (params) => {
        const isInEditMode =
          rowModesModel[params.id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <BootstrapTooltip title="ذخیره">
              <GridActionsCellItem
                icon={<SaveIcon color="success" />}
                label="Save"
                sx={{
                  color: "primary.main",
                }}
                onClick={handleSaveClick(params.id)}
              />
            </BootstrapTooltip>,
            <BootstrapTooltip title="انصراف">
              <GridActionsCellItem
                icon={<CancelIcon color="error" />}
                label="Cancel"
                className="textPrimary"
                onClick={handleCancelClick(params.id)}
                color="inherit"
              />
            </BootstrapTooltip>,
          ];
        }

        return [
          <BootstrapTooltip title="ویرایش">
            <GridActionsCellItem
              icon={<EditIcon color="primary" />}
              label="ویرایش"
              className="textPrimary"
              onClick={handleEditClick(params.id)}
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="حذف">
            <GridActionsCellItem
              icon={<DeleteIcon color="error" />}
              label="حذف"
              onClick={(event) =>
                handleDeleteClick(event, params.id.toString())
              }
              color="inherit"
            />
          </BootstrapTooltip>,

          <BootstrapTooltip title="موقعیت">
            <GridActionsCellItem
              icon={<LocationOnIcon color="primary" />}
              label="موقعیت"
              onClick={(event) =>
                handleDeleteClick(event, params.id.toString())
              }
              color="inherit"
            />
          </BootstrapTooltip>,
        ];
      },
    },
  ];
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    try {
      const res = await deleteAsync();
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      refetch();
      setRows((prevCities: ICity[]) =>
        prevCities.filter((city) => city.id !== parseInt(cityId, 10))
      );
      handleDeletePopoverClose();
    }
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenNewCity(true)}
        >
          شهر جدید
        </Button>
      </GridToolbarContainer>
    );
  }
  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const handleSaveClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const processRowUpdate = async (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    const res = await updateAsync(updatedRow);
    if (res.status) {
      refetch();
      setRows(
        rows.map((row: any) => (row.id === newRow.id ? updatedRow : row))
      );
      notifications.show("تغییرات اعمال شد!", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      notifications.show("مشکل در ذخیره ساز!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    }
    return updatedRow;
  };
  const [rows, setRows] = React.useState<any>();
  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row.id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row.id !== id));
    }
  };

  React.useEffect(() => {
    provinceInfo && setRows(provinceInfo.cities);
  }, [provinceInfo, user?.token]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              استان {provinceInfo && provinceInfo?.name}
            </Typography>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <PopoverComponent
            caption=" حذف انجام شود؟"
            anchorEl={anchorDeleteEl}
            handlePopoverClose={handleDeletePopoverClose}
            handler={handleDelete}
            id={idDeletePopover}
            isLoading={isDeleteLoading}
            open={openDeletePopover}
            key={"delete"}
          />

          <NewCity
            open={openNewCity}
            provinceId={provinceInfo?.id?.toString()}
            refetch={refetch}
            setOpen={setOpenNewCity}
            setRows={setRows}
          />
          <GridViewMUIX
            gridUniqueName="Cities"
            columns={columns}
            loading={false}
            EditToolbar={EditToolbar}
            rowModesModel={rowModesModel}
            processRowUpdate={processRowUpdate}
            rows={rows}
            setRowModesModel={setRowModesModel}
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
